/**
 * 輸送希望日タイプの定数定義
 */
export const yusouKibouBiType = {
  // 最短
  fastest: {
    value: 'fastest',
    label: '最短',
    description: '最短での輸送を希望',
  },

  // 希望日指定
  date_specified: {
    value: 'date_specified',
    label: '希望日指定',
    description: '特定の日付を指定して輸送を希望',
  },

  // 見積済（ロジコと調整済み）
  estimated_coordinated: {
    value: 'estimated_coordinated',
    label: '見積済（ロジコと調整済み）',
    description: 'ロジコと調整済みの見積もり日程での輸送',
  },
}

/**
 * 輸送希望日タイプの配列（選択肢として使用）
 */
export const yusouKibouBiTypeOptions = [
  yusouKibouBiType.fastest,
  yusouKibouBiType.date_specified,
  yusouKibouBiType.estimated_coordinated,
]

/**
 * 輸送希望日タイプの値から対応するオブジェクトを取得
 * @param {string} value
 * @returns {object|null}
 */
export const getYusouKibouBiTypeByValue = (value) => {
  return (
    Object.values(yusouKibouBiType).find((type) => type.value === value) || null
  )
}

/**
 * セレクトボックス等で使用する{text: label, value: value}形式の配列を取得
 * @returns {Array<{text: string, value: string}>}
 */
export const getYusouKibouBiTypeSelectOptions = () => {
  return Object.values(yusouKibouBiType).map((type) => ({
    text: type.label,
    value: type.value,
  }))
}

/**
 * 最短での輸送を希望しているかを判定
 * @param {string} kibouBiType 希望日タイプの値
 * @returns {boolean}
 */
export const isKibouBiTypeFastest = (kibouBiType) => {
  return kibouBiType === yusouKibouBiType.fastest.value
}

export default yusouKibouBiType



// WEBPACK FOOTER //
// ./src/constants/yusouKibouBiType.js